<template>
    <div class="index">
        <!-- banner -->
        <slider :sliderData="sliderData"></slider>
        <div class="wutuDiv w1200 margin-t40 margin-b40">
          <!-- 通知公告（无图）+ 院系新闻（带图）+ -->
          <div class="newListDiv flexDiv">
            <tzgg :tzggList='tzggList' moreLink = "/list.html?HType=2&CId=6620"></tzgg>
            <xwhd :xwhdList='xwhdList' moreLink = "/list.html?HType=2&CId=6621"></xwhd>
            <xgdt :xgdtList='xgdtList' moreLink = "/list.html?HType=2&CId=6630"></xgdt>
          </div>
          <!-- 国际联合培养 -->
          <div class="gjlh flexDiv">
            <p><i>国际联合培养</i></p>
            <ul class="flexDiv">
              <li v-for="(item,index) in gjlhList" :key="item.ID" class="wow fadeInLeft" :data-wow-delay="index/8+'s'">
              	<a :href="item.Url" class="imgBox">
                  <img :src="item.Cover" alt="">
              	</a>
                <span>{{item.Title}}</span>
              </li>
            </ul>
          </div>
        </div>
        <!-- 院系风采 -->
        <div class="yxfc w1200">
          <div class="title flexDiv">
          	<p>院系风采</p>
          </div>
          <div class="flexDiv">
            <div class="yxfcBox">
              <yxfc :yxfcList='yxfcList' moreLink = "/list.html?HType=2&CId=6626"></yxfc>
            </div>
            <div class="sp">
              <spsy :spsyList='spsyList' moreLink = "/list.html?HType=4&CId=6627"></spsy>
              <!-- <div class="shipin">
                <video id="video" controls="controls">
                    <source src="wjbobs.hope55.com/db/UploadFile/Media/782491cc-6b01-4930-978c-93f7487bae56.mp4" type="video/mp4"/>
                </video>
                <div class="dust"></div>
                <p class="play"><img src="../assets/img/play.png" alt=""></p>
              </div> -->
            </div>
          </div>
        </div>
    </div>
</template>
<script>
import '../assets/css/index.css';
import slider from '@/components/slider';
import xwhd from '@/components/xwhd';
import tzgg from '@/components/tzgg';
import yxfc from '@/components/yxfc';
import xgdt from '@/components/xgdt';
import spsy from '@/components/spsy';
export default {
    name:'index',
    components:{
      slider,
      xwhd,
      tzgg,
      yxfc,
      xgdt,
      spsy
    },
    data(){
      return{
        baseUrl:'this.baseUrl',
        sliderData:[],
        xwhdList:[],
        tzggList:[],
        yxfcList:[],
        xgdtList:[],
        spList:[],
        gjlhList:[],
        spsyList:[]
      }
    },
    created(){
        this.$root.$children['0'].$children['0'].menuListOne.forEach(element =>element.On = false)
        this.sliderData = this.Base.GetFilesInfoByCid(6636,1,'',6,1);
        this.xwhdList = this.Base.GetNewsInfoByCid(6621,true,1,'',1);
        this.tzggList = this.Base.GetNewsInfoByCid(6620,false,1,'',5);
        this.yxfcList = this.Base.GetNewsInfoByCid(6626,true,1,'',2);
        this.xgdtList = this.Base.GetNewsInfoByCid(6630,false,1,'',5);
        this.spsyList = this.Base.GetFilesInfoByCid(6627,1,'',1,1);
        this.gjlhList = this.Base.GetNewsInfoByCid(6811,true,1,'',4);
        // console.log(this.gjlhList);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/index.vue